import { render } from "./commandBar.vue?vue&type=template&id=06301ef0"
import script from "./commandBar.vue?vue&type=script&lang=js"
export * from "./commandBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__